export default "__VITE_ASSET__CfdKkUKc__"